module.exports = __webpack_public_path__ + "static/media/basketWide.d26d4820.svg";